import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { DragDropModule } from '@angular/cdk/drag-drop';

import { UppBaseModule } from '@unpispas/upp-base';
import { UppWdgtModule } from '@unpispas/upp-wdgt';
import { UppDataModule } from '@unpispas/upp-data';

import { FeatureProductModule }  from '@unpispas/feature/product';
import { FeatureOfferModule }  from '@unpispas/feature/offer';
import { FeatureExtraModule }  from '@unpispas/feature/extra';
import { FeatureQrCodeModule }  from '@unpispas/feature/qrcode';
import { FeatureClientModule } from '@unpispas/feature/client';
import { FeaturePinpadModule } from '@unpispas/feature/pinpad';

import { UppTicketEditComponent } from '../components/edit/upp-edit';
import { UppTicketthumbComponent } from '../components/thumb/upp-thumb';
import { UppTicketPrintComponent } from '../components/print/ticket/upp-print';
import { UppTicketInvoiceComponent } from '../components/invoice/upp-invoice';
import { UppTicketOrderComponent } from '../components/print/order/upp-print';
import { UppCartSelectComponent } from '../components/select/upp-select';
import { UppCashPayModalComponent } from '../components/modal/cash/upp-cash-modal';
import { UppCardPayModalComponent } from '../components/modal/card/upp-card-modal';

@NgModule({
    declarations: [
        UppTicketEditComponent,
        UppTicketthumbComponent,
        UppTicketInvoiceComponent,
        UppCartSelectComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        DragDropModule,
        UppBaseModule,
        UppWdgtModule,
        UppDataModule,
        FeatureProductModule,
        FeatureOfferModule,
        FeatureExtraModule,
        FeatureQrCodeModule,
        FeatureClientModule,
        FeaturePinpadModule,
        UppTicketPrintComponent,
        UppTicketOrderComponent,
        UppCashPayModalComponent,
        UppCardPayModalComponent,
    ],
    exports: [
        UppTicketEditComponent,
        UppTicketthumbComponent,
        UppTicketPrintComponent,
        UppTicketOrderComponent,
        UppCartSelectComponent,
        UppCashPayModalComponent,
        UppCardPayModalComponent,
        FeaturePinpadModule,
    ],    
    providers: [],  
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ]      
})
export class FeatureTicketModule {}
